<template>
  <div id="WinPage" class="win" ref="winContainer">
    <div class="breadcrumb">06&nbsp;&mdash;&nbsp;Wander &amp; Win</div>

    <button class="back-btn" v-if="currentPageState === 'form' || currentPageState === 're-entry'" v-on:click="goToWinEntry()">
      <div class="back-btn-icon">
        <back-nav></back-nav>
      </div>
      <span class="back-btn-text">Back</span>
    </button>

    <div class="parachuter-container">
      <parachuter ref="parachuter1" person="woman" />
      <parachuter ref="parachuter2" person="man" :delayed="true" />
    </div>
    <transition name="background-transition">
      <div v-if="!isTransitioning && currentPageState !== 'email-entry'" class="win-background"></div>
    </transition>
    <div v-if="currentPageState === 'email-entry'" class="win-background"></div>
    <img class="win-fern" data-src="./assets/win/win-fern.png">

    <div class="complete-text">
      <h1>Thanks for wandering with us</h1>
      <p>
        Our Wander &amp; Win Challenge may be over, but that doesn’t mean you have to stop exploring! So keep trying new things and treating yourself to the sweeter, yellow kiwi.
      </p>
    </div>
    
    <!-- <win-email-entry v-if="currentPageState === 'email-entry'"></win-email-entry>
    <p class="disclaimer">No Purchase Necessary. Begins 05/31/19 at 12:00:00 AM (ET) and ends on 10/21/19 at 11:59:59 PM (ET). Open only to legal residents of the 50 US &amp; DC who are 18+. 
      <a @click.prevent="openModal('rules')">See Official Rules</a> at zesprikiwi.com/wander for how to enter, additional eligibility restrictions, prize descriptions/restrictions and complete 
      details. Subject to complete <a @click.prevent="openModal('rules')">Official Rules</a>. 
      Void where prohibited. Sponsor: Zespri North America, Newport Beach, CA 92660.</p> -->
  </div>
</template>

<script>
import store from '../store'
import WinEntry from '../components/WinEntry.vue'
import WinForm from '../components/WinForm.vue'
import WinThanks from '../components/WinThanks.vue'
import WinEmailEntry from '../components/WinEmailEntry.vue'
import WinReEntry from '../components/WinReEntry.vue'
import Parachuter from '../components/Parachuter.vue'
import BackNav from '../assets/icons/back-nav.svg?inline'

export default {
  name: 'win',
  components: {
    // 'win-entry': WinEntry,
    // 'win-form': WinForm,
    // 'win-thanks': WinThanks,
    // 'win-re-entry': WinReEntry,
    // 'win-email-entry': WinEmailEntry,
    'parachuter': Parachuter,
    'back-nav': BackNav,
  },
  computed: {
    currentPageState() {
	    return store.state.winState
    },
    isTransitioning() {
      return store.state.isTransitioning
    }
  },
  props: {
    active: {
      default: true,
      type: Boolean
    }
  },
  watch: {
    active(active) {
      if (active) {
        this.$refs.parachuter1.play()
        this.$refs.parachuter2.play()
      } else {
        this.$refs.parachuter1.pause()
        this.$refs.parachuter2.pause()
      }
    },
    currentPageState() {
      store.commit('startTransition')
    }
  },
  methods:{
    openModal(whichModal) {
      store.commit('openModal', whichModal)
    },
    startHeightChange() {
      this.$emit('sectionHeightChange')
    },
    goToWinEntry() {
      store.commit('goToWinEntry')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../theme';

// Page Transitions
.win-page-transition-enter-active, .win-page-transition-leave-active {
  transition: all .5s;
}

.win-page-transition-enter {
  opacity: 0;
  transform: translateX(100%);
}

.win-page-transition-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}

.win-page-transition-enter-active {
  transition-delay: .5s;
}

.background-transition-enter-active, .background-transition-leave-active {
  transition: all .5s;
}

.background-transition-enter {
  opacity: 0;
}

.background-transition-leave-active {
  opacity: 0;
}

.background-transition-enter-active {
  transition-delay: .5s;
}

.win {
  position: relative;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;

  @include media-breakpoint-up(md) {
    padding: 6% 8%;
  }

  .win-background {
    position: absolute;
    z-index: zespri-layer(background);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image:
      url('../assets/win/win-sea-background.png'),
      url('../assets/win/win-sky-background.jpg');
    background-position:
      bottom right,
      top center;
    background-repeat: no-repeat;
    background-size:
      300%,
      cover;

    @include media-breakpoint-up(sm) {
      background-size:
        150%,
        cover;
    }

    @include media-breakpoint-up(md) {
      background-size:
        100%,
        cover;
    }

    @include media-breakpoint-up(lg) {
      background-size:
        contain,
        cover;
    }
  }

  .breadcrumb {
    position: absolute;
    @include zespri-tiny-title;
    color: zespri-brand-color(white);
    left: 32px;
    top: 40px;
    z-index: zespri-layer(normal);

    @include media-breakpoint-up(md) {
      left: 8%;
    }
  }

  .win-fern {
    position: absolute;
    top: 0;
    right: 0;
    width: 25%;
  }
}

.parachuter-container {
  @include absolute-fill;
  overflow: hidden;
}

.back-btn {
  border: none;
  display: flex;
  align-items: center;
  width: 110px;
  background: transparent;
  cursor: pointer;
  margin: 50px 0 -20px 0;
  z-index: zespri-layer(normal);
  
  @include media-breakpoint-up(md) {
    margin: 0;
  }

  .back-btn-icon {
    fill: zespri-brand-color(dark-green);
    margin-right: 15px;
    width: 35px;
    transition: fill .2s;
    
    svg {
      width: 35px;
    }
  }

  .back-btn-text {
    @include zespri-title-font;
    color: zespri-brand-color(dark-green);
    font-size: 15px;
    transition: color .2s;
  }

  &:hover {
    .back-btn-icon {
      fill: zespri-brand-color(green);
    }

    .back-btn-text {
      color: zespri-brand-color(green);
    }
  }
  
  &:focus {
    outline: 0;
  }
}

.complete-text{
  max-width: 600px;
  margin: 30px auto;
  position: relative;
  align-self: center;
  h1{
    font-size: 50px;
  }
  p{
    color: zespri-brand-color(white);
    text-shadow: 0.5px 0.5px 1px zespri-brand-color(dark-green);
    @include media-breakpoint-up(sm) {
      color: zespri-brand-color(dark-green);
      text-shadow: 0.5px 0.5px 1px zespri-brand-color(white);
    }
  }
}

.disclaimer{
  color: zespri-brand-color(white);
  align-self: center;
  font-size: 12px;
  max-width: 600px;
  margin: 30px auto;
  text-shadow: 0.5px 0.5px 1px zespri-brand-color(dark-green);
  z-index: zespri-layer(normal);
}

.disclaimer a{
  color: zespri-brand-color(white);
  text-decoration: underline;
  cursor: pointer;
}
</style>
